import '@/assets/css/common.pc.css'
import '@/assets/css/ui.css'

//tips_data
globalThis.tips_data = {};

globalThis.mainApp = null;

import Vue from 'vue'
import App from './index.vue'

import {
  imgsPreloader
} from '@/assets/js/imgPreloader.js';
import imgPreloaderList from '@/assets/js/imgPreloaderList.js';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL

/*全局引入*/
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;

//login
import mslogin from '@/assets/js/msLogin.js'
Vue.prototype.$mslogin = mslogin
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login

// rule
import Rule from '@/components/EvtRule'
Vue.prototype.$rule_modal = Rule

//FREE
import Free_login from '@/assets/js/freeLogin.js';

// Toast
import Toast from '@/components/Toast'
Vue.prototype.$toast = Toast;

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// skin
import Skin from '@/components/SkinModal'
Vue.prototype.$skin_modal = Skin;

// skin
import Detail from '@/components/SkinDetail'
Vue.prototype.$detail_modal = Detail;

// vote
import Vote from '@/components/VoteModal'
Vue.prototype.$vote_modal = Vote;

// submit
import Submit from '@/components/SubmitModal'
Vue.prototype.$submit_modal = Submit;

// share_Modal
import Share_Modal from '@/components/ShareModal';
Vue.prototype.$share_modal = Share_Modal;

// video_Modal
import Video_Modal from '@/components/video';
Vue.prototype.$video_modal = Video_Modal;

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem)

// item_tips
import Item_Tips from '@/components/ItemTipsPC/itemTipsPC.vue';
Vue.component('item-tips',Item_Tips);
//tips-pc
Vue.prototype.$tips_on = function(e,id,type){
    if(GLOBAL.deviceType != 'pc') return;
    mainApp.$refs.app.$refs.tips.visible = true;
    mainApp.$refs.app.$refs.tips.item_id = id;
    mainApp.$refs.app.$refs.tips.pos_data = {
        x : e.clientX,
        y : e.clientY,
    };
    if(type)mainApp.$refs.app.$refs.tips.type = type;
};

Vue.prototype.$tips_off = function(){
    mainApp.$refs.app.$refs.tips.visible = false;
};

Vue.prototype.$item_tips = function(id,type){
  if(GLOBAL.deviceType == 'pc') return;
};

Vue.prototype.$update_ua = function (data) {
  mainApp.ua = data;
};

Vue.prototype.$update_ua_info = function (data) {
  mainApp.ua.nickName = data.nickName;
  mainApp.ua.areaId = data.areaId;
};

Vue.prototype.$update_evt = function (data) {
  mainApp.evt_info = data;
};

Vue.prototype.$update_userType = function () {
  mainApp.evt_info.uflag = mainApp.evt_info.uflag >= 10 ? mainApp.evt_info.uflag : mainApp.evt_info.uflag + 10;
};

Vue.prototype.$update_userType_select = function (data) {
  mainApp.evt_info.uflag = data;
};

/* eslint-disable no-new */
(async () => {
  await imgsPreloader(imgPreloaderList);
  //关闭加载弹框
  document.querySelector('.loading').style.display = 'none';
  /* eslint-disable no-new */
  mainApp = new Vue({
    el: '#app',
    components: {
      App
    },
    template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login" :time="time"/>',
    data() {
      return {
        ua: {},
        evt_info: {},
        code: '',
        name: null,
        login: 0, //登陆
        aid: 0, //大区id
        account_type: 'pc',
        isLoading: false,
        ready: false, //通信阀门 
        time : 0,           
      }
    },
    created() {
      var _this = this;

      let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
      _this.token = token;

      if (token) {
        localStorage.setItem('token', token);
        if (GLOBAL.getQueryVariable('authorization')) {
          window.history.pushState({}, 0, GLOBAL.domain);
        }
      }

      var instance = axios.create();
      instance.defaults.timeout = 1000 * 20;
      axios.defaults.headers.post['Content-Type'] = 'application/json';

      /* 请求拦截 */
      this.$axios.interceptors.request.use(
        config => {

          if (_this.token != null) {
            config.headers["Authorization"] = _this.token;
          }

          if (config.url != ajax_url_map.tips) {
            config.headers["issn"] = GLOBAL.issn;
          }

          return config;
        },
        err => Promise.reject(err)
      );

      //请求返回拦截
      this.$axios.interceptors.response.use((response) => {
        //this.$loading.hide();
        if (response.data.code === 2) {
          //其余错误状态处理
          return Promise.reject(response.data);
        } else if (response.data.code === 401) {
          //未登录        
          localStorage.clear();
          _this.token = '';

          return Promise.reject(response.data);
        } else if (response.data.code === 402) {
          //未绑定大区
          this.$bind_modal();

          return Promise.reject(response.data);
        } else if (response.data.code !== 0) {
          return Promise.reject(response.data);
        }

        return response.data;

      }, function (error) {
        //this.$loading.hide();
        return console.log(error);
      });
    },
    mounted (){
        this.get_user_info();
    
        // wx.wxInit({
        //   title: GLOBAL.wx_share_text.title, // 分享标题
        //   desc: GLOBAL.wx_share_text.desc, // 分享描述
        //   link: GLOBAL.domain, // 分享链接
        //   imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        // });  
    
      },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        Free_login.free_login_lazy(
          this.ua.uid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.free,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
            }
            _this.update_evt();

          }
        );
      },
      update_login() {
        let _this = this;

        return new Promise((resolve, reject) => {
          _this.$axios.get(ajax_url_map.logininfo)
            .then(
              res => {
                _this.login = 1;
                _this.ua = res.data;
                resolve(res);
              },
              rej => {
                //reject(rej);
                this.ready = true
              }
            )
            .catch(function (error) {
              console.log(error);
            });
        });

      },
      update_evt() {
        let _this = this;

        async function _evt_init() {
          let _data = await _this.update_login();
          console.log(_data);
          if (!_data.data.areaId) {
            _this.ready = true;
            return _this.$bind_modal();
          }

          _this.$axios.post(ajax_url_map.userinfo)
            .then(
              res => {
                _this.evt_info = res.data;
                _this.ready = true;
                _this.time = res.time;
              },
              rej => {

                _this.ready = true;
              }
            )
        }

        _evt_init();
      },
    },
  })
})();



// WEBPACK FOOTER //
// ./src/view/index/index.js